module.exports = __webpack_public_path__ + "static/media/add sticker.2014c0b4.png";